type SupportedLanguage = 'bg' | 'en' | 'nl' | 'tr' | 'pl';

interface TagCanonicalLabel {
  bg: string;
  en: string;
  nl: string;
  tr: string;
  pl: string;
}

const TAG_LABELS: Record<string, TagCanonicalLabel> = {
  urgent: { bg: 'Спешно', en: 'Urgent', nl: 'Dringend', tr: 'Acil', pl: 'Pilne' },
  remote: { bg: 'Отдалечено', en: 'Remote', nl: 'Op afstand', tr: 'Uzaktan', pl: 'Zdalnie' },
  on_site: { bg: 'На място', en: 'On-site', nl: 'Ter plaatse', tr: 'Yerinde', pl: 'Na miejscu' },
  beginner: { bg: 'Начинаещ', en: 'Beginner', nl: 'Beginner', tr: 'Başlangıç', pl: 'Początkujący' },
  expert: { bg: 'Експерт', en: 'Expert', nl: 'Expert', tr: 'Uzman', pl: 'Ekspert' },
  small_budget: { bg: 'Малък бюджет', en: 'Small Budget', nl: 'Klein budget', tr: 'Küçük Bütçe', pl: 'Mały budżet' },
  large_budget: { bg: 'Голям бюджет', en: 'Large Budget', nl: 'Groot budget', tr: 'Büyük Bütçe', pl: 'Duży budżet' },
  one_time: { bg: 'Еднократно', en: 'One-time', nl: 'Eenmalig', tr: 'Tek seferlik', pl: 'Jednorazowo' },
  periodic: { bg: 'Периодично', en: 'Periodic', nl: 'Periodiek', tr: 'Periyodik', pl: 'Okresowo' },
  long_term: { bg: 'Дългосрочно', en: 'Long-term', nl: 'Langdurig', tr: 'Uzun vadeli', pl: 'Długoterminowo' },
  renovation: { bg: 'Ремонт', en: 'Renovation', nl: 'Renovatie', tr: 'Tadilat', pl: 'Remont' },
  new_construction: { bg: 'Ново строителство', en: 'New Construction', nl: 'Nieuwbouw', tr: 'Yeni İnşaat', pl: 'Nowe budownictwo' },
  electrical_installations: { bg: 'Електроинсталации', en: 'Electrical Installations', nl: 'Elektrische installaties', tr: 'Elektrik Tesisatı', pl: 'Instalacje elektryczne' },
  plumbing_services: { bg: 'ВиК услуги', en: 'Plumbing Services', nl: 'Loodgietersdiensten', tr: 'Tesisat Hizmetleri', pl: 'Usługi hydrauliczne' },
  insulation: { bg: 'Изолация', en: 'Insulation', nl: 'Isolatie', tr: 'Yalıtım', pl: 'Izolacja' },
  windows_doors: { bg: 'Дограма', en: 'Windows & Doors', nl: 'Ramen en deuren', tr: 'Pencere ve Kapılar', pl: 'Okna i drzwi' },
  web_development: { bg: 'Уеб разработка', en: 'Web Development', nl: 'Webontwikkeling', tr: 'Web Geliştirme', pl: 'Tworzenie stron' },
  mobile_apps: { bg: 'Мобилни приложения', en: 'Mobile Apps', nl: 'Mobiele apps', tr: 'Mobil Uygulamalar', pl: 'Aplikacje mobilne' },
  computer_support: { bg: 'Поддръжка на компютри', en: 'Computer Support', nl: 'Computerondersteuning', tr: 'Bilgisayar Desteği', pl: 'Wsparcie komputerowe' },
  networks_servers: { bg: 'Мрежи и сървъри', en: 'Networks & Servers', nl: 'Netwerken en servers', tr: 'Ağlar ve Sunucular', pl: 'Sieci i serwery' },
  cybersecurity: { bg: 'Киберсигурност', en: 'Cybersecurity', nl: 'Cyberbeveiliging', tr: 'Siber Güvenlik', pl: 'Cyberbezpieczeństwo' },
  cloud_services: { bg: 'Облачни услуги', en: 'Cloud Services', nl: 'Cloudservices', tr: 'Bulut Hizmetleri', pl: 'Usługi chmurowe' },
  accounting: { bg: 'Счетоводство', en: 'Accounting', nl: 'Boekhouding', tr: 'Muhasebe', pl: 'Księgowość' },
  marketing: { bg: 'Маркетинг', en: 'Marketing', nl: 'Marketing', tr: 'Pazarlama', pl: 'Marketing' },
  business_consulting: { bg: 'Бизнес консултации', en: 'Business Consulting', nl: 'Bedrijfsadvies', tr: 'İş Danışmanlığı', pl: 'Doradztwo biznesowe' },
  human_resources: { bg: 'Човешки ресурси', en: 'Human Resources', nl: 'Human resources', tr: 'İnsan Kaynakları', pl: 'Zasoby ludzkie' },
  translation_services: { bg: 'Преводи', en: 'Translation Services', nl: 'Vertaaldiensten', tr: 'Çeviri Hizmetleri', pl: 'Tłumaczenia' },
  private_lessons: { bg: 'Частни уроци', en: 'Private Lessons', nl: 'Privelessen', tr: 'Özel Dersler', pl: 'Korepetycje' },
  language_courses: { bg: 'Езикови курсове', en: 'Language Courses', nl: 'Taalcursussen', tr: 'Dil Kursları', pl: 'Kursy językowe' },
  programming_courses: { bg: 'Програмиране', en: 'Programming', nl: 'Programmeren', tr: 'Programlama', pl: 'Programowanie' },
  music_training: { bg: 'Музикално обучение', en: 'Music Training', nl: 'Muziekopleiding', tr: 'Müzik Eğitimi', pl: 'Nauka muzyki' },
  exam_preparation: { bg: 'Подготовка за изпити', en: 'Exam Preparation', nl: 'Examenvoorbereiding', tr: 'Sınav Hazırlığı', pl: 'Przygotowanie do egzaminów' },
  graphic_design: { bg: 'Графичен дизайн', en: 'Graphic Design', nl: 'Grafisch ontwerp', tr: 'Grafik Tasarım', pl: 'Projektowanie graficzne' },
  web_design: { bg: 'Уеб дизайн', en: 'Web Design', nl: 'Webdesign', tr: 'Web Tasarımı', pl: 'Projektowanie stron' },
  interior_design: { bg: 'Интериорен дизайн', en: 'Interior Design', nl: 'Interieurontwerp', tr: 'İç Mimari', pl: 'Projektowanie wnętrz' },
  product_design: { bg: 'Продуктов дизайн', en: 'Product Design', nl: 'Productontwerp', tr: 'Ürün Tasarımı', pl: 'Projektowanie produktu' },
  modeling_3d: { bg: '3D моделиране', en: '3D Modeling', nl: '3D-modellering', tr: '3D Modelleme', pl: 'Modelowanie 3D' },
  fitness: { bg: 'Фитнес', en: 'Fitness', nl: 'Fitness', tr: 'Fitness', pl: 'Fitness' },
  yoga: { bg: 'Йога', en: 'Yoga', nl: 'Yoga', tr: 'Yoga', pl: 'Joga' },
  massages: { bg: 'Масажи', en: 'Massages', nl: 'Massages', tr: 'Masaj', pl: 'Masaże' },
  psychotherapy: { bg: 'Психотерапия', en: 'Psychotherapy', nl: 'Psychotherapie', tr: 'Psikoterapi', pl: 'Psychoterapia' },
  nutritionist: { bg: 'Нутриционист', en: 'Nutritionist', nl: 'Voedingsdeskundige', tr: 'Diyetisyen', pl: 'Dietetyk' },
  laundry_ironing: { bg: 'Пране и гладене', en: 'Laundry & Ironing', nl: 'Wassen en strijken', tr: 'Çamaşır ve Ütü', pl: 'Pranie i prasowanie' },
  home_repairs: { bg: 'Домашни ремонти', en: 'Home Repairs', nl: 'Huisreparaties', tr: 'Ev Tamiratı', pl: 'Naprawy domowe' },
  decoration: { bg: 'Декорация', en: 'Decoration', nl: 'Decoratie', tr: 'Dekorasyon', pl: 'Dekoracja' },
  freight_transport: { bg: 'Товарен транспорт', en: 'Freight Transport', nl: 'Vrachtvervoer', tr: 'Yük Taşımacılığı', pl: 'Transport towarowy' },
  moving_services: { bg: 'Хамалски услуги', en: 'Moving Services', nl: 'Verhuisdiensten', tr: 'Nakliye Hizmetleri', pl: 'Usługi przeprowadzkowe' },
  relocation: { bg: 'Преместване', en: 'Relocation', nl: 'Verhuizing', tr: 'Taşınma', pl: 'Przeprowadzka' },
  courier_services: { bg: 'Куриерски услуги', en: 'Courier Services', nl: 'Koeriersdiensten', tr: 'Kurye Hizmetleri', pl: 'Usługi kurierskie' },
  taxi_services: { bg: 'Таксиметрови услуги', en: 'Taxi Services', nl: 'Taxidiensten', tr: 'Taksi Hizmetleri', pl: 'Usługi taxi' },
  legal_representation: { bg: 'Адвокатски услуги', en: 'Legal Representation', nl: 'Juridische vertegenwoordiging', tr: 'Hukuki Temsil', pl: 'Reprezentacja prawna' },
  notary_services: { bg: 'Нотариални услуги', en: 'Notary Services', nl: 'Notariële diensten', tr: 'Noter Hizmetleri', pl: 'Usługi notarialne' },
  property_law: { bg: 'Имотно право', en: 'Property Law', nl: 'Vastgoedrecht', tr: 'Gayrimenkul Hukuku', pl: 'Prawo nieruchomości' },
  labor_law: { bg: 'Трудово право', en: 'Labor Law', nl: 'Arbeidsrecht', tr: 'İş Hukuku', pl: 'Prawo pracy' },
  corporate_law: { bg: 'Корпоративно право', en: 'Corporate Law', nl: 'Ondernemingsrecht', tr: 'Şirketler Hukuku', pl: 'Prawo korporacyjne' },
  music: { bg: 'Музика', en: 'Music', nl: 'Muziek', tr: 'Müzik', pl: 'Muzyka' },
  photography: { bg: 'Фотография', en: 'Photography', nl: 'Fotografie', tr: 'Fotoğrafçılık', pl: 'Fotografia' },
  videography: { bg: 'Видеозаснемане', en: 'Videography', nl: 'Videografie', tr: 'Videografi', pl: 'Wideofilmowanie' },
  event_planning: { bg: 'Организиране на събития', en: 'Event Planning', nl: 'Evenementenorganisatie', tr: 'Etkinlik Organizasyonu', pl: 'Organizacja eventów' },
  art_services: { bg: 'Художествени услуги', en: 'Art Services', nl: 'Kunstdiensten', tr: 'Sanat Hizmetleri', pl: 'Usługi artystyczne' },
  painting: { bg: 'Боядисване', en: 'Painting', nl: 'Schilderwerk', tr: 'Boya İşleri', pl: 'Malowanie' },
  plumbing_short: { bg: 'ВиК', en: 'Plumbing', nl: 'Loodgieterij', tr: 'Tesisat', pl: 'Hydraulika' },
  gardening_services: { bg: 'Градинарство', en: 'Gardening', nl: 'Tuinieren', tr: 'Bahçıvanlık', pl: 'Ogrodnictwo' },
  electrical_short: { bg: 'Електро', en: 'Electrical', nl: 'Elektriciteit', tr: 'Elektrik', pl: 'Elektryka' },
  cleaning_services: { bg: 'Почистване', en: 'Cleaning', nl: 'Schoonmaak', tr: 'Temizlik', pl: 'Sprzątanie' },
};

const TAG_ALIASES: Record<string, keyof typeof TAG_LABELS> = {
  urgent: 'urgent',
  спешно: 'urgent',
  dringend: 'urgent',
  remote: 'remote',
  отдалечено: 'remote',
  'op afstand': 'remote',
  'on-site': 'on_site',
  onsite: 'on_site',
  'on site': 'on_site',
  'на място': 'on_site',
  'ter plaatse': 'on_site',
  beginner: 'beginner',
  начинаещ: 'beginner',
  expert: 'expert',
  експерт: 'expert',
  'small budget': 'small_budget',
  'малък бюджет': 'small_budget',
  'klein budget': 'small_budget',
  'large budget': 'large_budget',
  'голям бюджет': 'large_budget',
  'groot budget': 'large_budget',
  'one-time': 'one_time',
  'one time': 'one_time',
  еднократно: 'one_time',
  eenmalig: 'one_time',
  periodic: 'periodic',
  периодично: 'periodic',
  periodiek: 'periodic',
  'long-term': 'long_term',
  'long term': 'long_term',
  дългосрочно: 'long_term',
  langdurig: 'long_term',
  ремонт: 'renovation',
  renovation: 'renovation',
  renovatie: 'renovation',
  'ново строителство': 'new_construction',
  'new construction': 'new_construction',
  nieuwbouw: 'new_construction',
  електроинсталации: 'electrical_installations',
  'electrical installations': 'electrical_installations',
  'elektrische installaties': 'electrical_installations',
  'вик услуги': 'plumbing_services',
  'plumbing services': 'plumbing_services',
  loodgietersdiensten: 'plumbing_services',
  изолация: 'insulation',
  insulation: 'insulation',
  isolatie: 'insulation',
  дограма: 'windows_doors',
  'windows & doors': 'windows_doors',
  'windows and doors': 'windows_doors',
  'ramen en deuren': 'windows_doors',
  'уеб разработка': 'web_development',
  'web development': 'web_development',
  webontwikkeling: 'web_development',
  'мобилни приложения': 'mobile_apps',
  'mobile apps': 'mobile_apps',
  'mobiele apps': 'mobile_apps',
  'поддръжка на компютри': 'computer_support',
  'computer support': 'computer_support',
  computerondersteuning: 'computer_support',
  'мрежи и сървъри': 'networks_servers',
  'networks & servers': 'networks_servers',
  'networks and servers': 'networks_servers',
  'netwerken en servers': 'networks_servers',
  киберсигурност: 'cybersecurity',
  cybersecurity: 'cybersecurity',
  cyberbeveiliging: 'cybersecurity',
  'облачни услуги': 'cloud_services',
  'cloud services': 'cloud_services',
  cloudservices: 'cloud_services',
  счетоводство: 'accounting',
  accounting: 'accounting',
  boekhouding: 'accounting',
  маркетинг: 'marketing',
  'бизнес консултации': 'business_consulting',
  'business consulting': 'business_consulting',
  bedrijfsadvies: 'business_consulting',
  'човешки ресурси': 'human_resources',
  'human resources': 'human_resources',
  'преводи': 'translation_services',
  'translation services': 'translation_services',
  vertaaldiensten: 'translation_services',
  'частни уроци': 'private_lessons',
  'private lessons': 'private_lessons',
  privelessen: 'private_lessons',
  'езикови курсове': 'language_courses',
  'language courses': 'language_courses',
  taalcursussen: 'language_courses',
  програмиране: 'programming_courses',
  programming: 'programming_courses',
  programmeren: 'programming_courses',
  'музикално обучение': 'music_training',
  'music training': 'music_training',
  muziekopleiding: 'music_training',
  'подготовка за изпити': 'exam_preparation',
  'exam preparation': 'exam_preparation',
  examenvoorbereiding: 'exam_preparation',
  'графичен дизайн': 'graphic_design',
  'graphic design': 'graphic_design',
  'grafisch ontwerp': 'graphic_design',
  'уеб дизайн': 'web_design',
  'web design': 'web_design',
  webdesign: 'web_design',
  'интериорен дизайн': 'interior_design',
  'interior design': 'interior_design',
  interieurontwerp: 'interior_design',
  'продуктов дизайн': 'product_design',
  'product design': 'product_design',
  productontwerp: 'product_design',
  '3d моделиране': 'modeling_3d',
  '3d modeling': 'modeling_3d',
  '3d-modellering': 'modeling_3d',
  фитнес: 'fitness',
  йога: 'yoga',
  масажи: 'massages',
  massages: 'massages',
  психотерапия: 'psychotherapy',
  psychotherapy: 'psychotherapy',
  psychotherapie: 'psychotherapy',
  нутриционист: 'nutritionist',
  nutritionist: 'nutritionist',
  voedingsdeskundige: 'nutritionist',
  'пране и гладене': 'laundry_ironing',
  'laundry & ironing': 'laundry_ironing',
  'laundry and ironing': 'laundry_ironing',
  'wassen en strijken': 'laundry_ironing',
  'домашни ремонти': 'home_repairs',
  'home repairs': 'home_repairs',
  huisreparaties: 'home_repairs',
  декорация: 'decoration',
  decoration: 'decoration',
  decoratie: 'decoration',
  'товарен транспорт': 'freight_transport',
  'freight transport': 'freight_transport',
  vrachtvervoer: 'freight_transport',
  'хамалски услуги': 'moving_services',
  'moving services': 'moving_services',
  verhuisdiensten: 'moving_services',
  преместване: 'relocation',
  relocation: 'relocation',
  verhuizing: 'relocation',
  'куриерски услуги': 'courier_services',
  'courier services': 'courier_services',
  koeriersdiensten: 'courier_services',
  'таксиметрови услуги': 'taxi_services',
  'taxi services': 'taxi_services',
  taxidiensten: 'taxi_services',
  'адвокатски услуги': 'legal_representation',
  'legal representation': 'legal_representation',
  'juridische vertegenwoordiging': 'legal_representation',
  'нотариални услуги': 'notary_services',
  'notary services': 'notary_services',
  'notariële diensten': 'notary_services',
  'имотно право': 'property_law',
  'property law': 'property_law',
  vastgoedrecht: 'property_law',
  'трудово право': 'labor_law',
  'labor law': 'labor_law',
  arbeidsrecht: 'labor_law',
  'корпоративно право': 'corporate_law',
  'corporate law': 'corporate_law',
  ondernemingsrecht: 'corporate_law',
  музика: 'music',
  muziek: 'music',
  фотография: 'photography',
  fotografie: 'photography',
  видеозаснемане: 'videography',
  videography: 'videography',
  videografie: 'videography',
  'организиране на събития': 'event_planning',
  'event planning': 'event_planning',
  evenementenorganisatie: 'event_planning',
  'художествени услуги': 'art_services',
  'art services': 'art_services',
  kunstdiensten: 'art_services',
  боядисване: 'painting',
  painting: 'painting',
  schilderwerk: 'painting',
  вик: 'plumbing_short',
  'ви к': 'plumbing_short',
  plumbing: 'plumbing_short',
  loodgieterij: 'plumbing_short',
  градинарство: 'gardening_services',
  gardening: 'gardening_services',
  tuinieren: 'gardening_services',
  електро: 'electrical_short',
  electrical: 'electrical_short',
  elektriciteit: 'electrical_short',
  почистване: 'cleaning_services',
  cleaning: 'cleaning_services',
  schoonmaak: 'cleaning_services',
};

const normalizeLabel = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ');

// Функция за превод на таг
export const translateTag = (tagName: string, language: string): string => {
  if (!tagName) return '';

  const code = language.split('-')[0];
  const normalizedLanguage: SupportedLanguage =
    code === 'bg' || code === 'en' || code === 'nl' || code === 'tr' || code === 'pl'
      ? code
      : 'en';

  const aliasKey = normalizeLabel(tagName);
  const keyFromNormalized = aliasKey.replace(/\s+/g, '_');
  const canonicalKey = TAG_ALIASES[aliasKey] || (TAG_LABELS[keyFromNormalized] ? keyFromNormalized : undefined);
  if (!canonicalKey) {
    return tagName;
  }

  return TAG_LABELS[canonicalKey][normalizedLanguage];
};